// src/config/businessNames.js

const businessNames = [
  // Medical & Health
  { value: "மருத்துவர்", label: "Doctor (மருத்துவர்)" },
  { value: "கால்நடை மருத்துவர்", label: "Veterinary Doctor (கால்நடை மருத்துவர்)" },
  { value: "சித்த மருத்துவம்", label: "Siddha Doctor (சித்த மருத்துவம்)" },
  { value: "ஆயுர்வேத மருத்துவர்", label: "Ayurveda Doctor (ஆயுர்வேத மருத்துவர்)" },
  { value: "பல் மருத்துவர்", label: "Dentist (பல் மருத்துவர்)" },


  // Education & Training
  { value: "ஆசிரியர்", label: "Teacher (ஆசிரியர்)" },
  { value: "முதன்மை ஆசிரியர்", label: "Head Teacher (முதன்மை ஆசிரியர்)" },
  { value: "பயிற்சியாளர்", label: "Instructor (பயிற்சியாளர்)" },
  { value: "கல்வி பயிற்சி", label: "Education Trainer (கல்வி பயிற்சி)" },
  { value: "பேராசிரியர்", label: "Professor (பேராசிரியர்)" },

  // Engineering & Technology
  { value: "சிவில் பொறியாளர்", label: "Civil Engineer (சிவில் பொறியாளர்)" },
  { value: "மின் பொறியாளர்", label: "Electrical Engineer (மின் பொறியாளர்)" },
  { value: "எலக்ட்ரீஷியன்", label: "Electrician (எலக்ட்ரீஷியன்)" },
  { value: "பொறியாளர்", label: "Engineer (பொறியாளர்)" },
  { value: "தகவல் தொழில்நுட்பம்", label: "IT (தகவல் தொழில்நுட்பம்)" },
  { value: "தொழில்நுட்ப உதவியாளர்", label: "Tech Support (தொழில்நுட்ப உதவியாளர்)" },

  // Agriculture & Allied Fields
  { value: "விவசாயி", label: "Farmer (விவசாயி)" },
  { value: "விவசாய துறை", label: "Agriculture Department (விவசாய துறை)" },
  { value: "கோழி பண்ணை", label: "Poultry Farm (கோழி பண்ணை)" },

  // Business & Trade
  { value: "வணிகம்", label: "Business (வணிகம்)" },
  { value: "வணிக ஆலோசகர்", label: "Business Consultant (வணிக ஆலோசகர்)" },
  { value: "ரியல் எஸ்டேட்", label: "Real Estate (ரியல் எஸ்டேட்)" },
  { value: "நிதி", label: "Finance (நிதி)" },
  { value: "நகை வியாபாரி", label: "Jeweller (நகை வியாபாரி)" },
  { value: "விற்பனையாளர்", label: "Salesman (விற்பனையாளர்)" },
  { value: "சேர் வணிகர்", label: "Shopkeeper (சேர் வணிகர்)" },
  { value: "வெளிச்சத்திற்கான விற்பனையாளர்", label: "Lighting Salesperson (வெளிச்சத்திற்கான விற்பனையாளர்)" },
  { value: "மொபைல் கடை", label: "Mobile Shop (மொபைல் கடை)" },
  { value: "நூல் கடை", label: "Thread Shop (நூல் கடை)" },
  { value: "பேக்கரி", label: "Bakery (பேக்கரி)" },
  { value: "ஜவுளி", label: "Textile (ஜவுளி/தரி)" },
  { value: "மளிகை கடை", label: "Grocery Store (மளிகை கடை)" },
  { value: "ஆழ்துளை கிணறு", label: "Bore Well (ஆழ்துளை கிணறு)" },



  // Legal, Administrative & Government
  { value: "விஆஓ", label: "VAO (விஆஓ)" },
  { value: "வழக்கறிஞர்", label: "Lawyer (வழக்கறிஞர்)" },
  { value: "நிருவாக உதவியாளர்", label: "Administrative Assistant (நிருவாக உதவியாளர்)" },
  { value: "பணியில் இருந்து ஓய்வு", label: "Retired (பணியில் இருந்து ஓய்வு)" },
  { value: "காப்பீட்டு முகவர்", label: "Insurance Agent (காப்பீட்டு முகவர்)" },
  { value: "வங்கி மேலாளர்", label: "Bank Manager (வங்கி மேலாளர்)" },
  { value: "காவல் துறை", label: "Police (காவல் துறை)" },
  { value: "விற்பனை மேலாளர்", label: "Sales Manager (விற்பனை மேலாளர்)" },

  // Construction & Skilled Trades
  { value: "மெக்கானிக்", label: "Mechanic (மெக்கானிக்)" },
  { value: "மரம் உரிக்கும் மில்", label: "Saw Mill (மரம் உரிக்கும் மில்)" },
  { value: "படைவழிபவர்", label: "Carpenter (படைவழிபவர்)" },
  { value: "சிற்பி", label: "Sculptor (சிற்பி)" },
  { value: "தையல்காரர்", label: "Tailor (தையல்காரர்)" },
  { value: "அச்சகம்", label: "Printing Press (அச்சகம்)" },
  { value: "தொழிலாளர்", label: "Labour (தொழிலாளர்)" },
  { value: "கைத்தொழிலாளர்", label: "Artisan (கைத்தொழிலாளர்)" },

  // Transportation
  { value: "ஓட்டுனர்", label: "Driver (ஓட்டுனர்)" },
  { value: "விமானி", label: "Pilot (விமானி)" },
  { value: "போக்குவரத்து சேவைகள்", label: "Transport Services (போக்குவரத்து சேவைகள்)" },
  { value: "நடவடிக்கை மண்டலர்", label: "Conductor (நடவடிக்கை மண்டலர்)" },
  { value: "பஞ்சர் கடை", label: "Puncher Shop (பஞ்சர் கடை)" },

  // Media, Arts & Culture
  { value: "எழுத்தாளர்", label: "Writer (எழுத்தாளர்)" },
  { value: "செய்தி ஆசிரியர்", label: "Journalist (செய்தி ஆசிரியர்)" },
  { value: "பத்திரிகையாளர்", label: "Reporter (பத்திரிகையாளர்)" },
  { value: "புகைப்படக்காரர்", label: "Photographer (புகைப்படக்காரர்)" },
  { value: "இலக்கிய எழுத்தாளர்", label: "Literary Writer (இலக்கிய எழுத்தாளர்)" }, // optionally add back
  { value: "பூசாரி", label: "Priest (பூசாரி)" },

  // Science & Research
  { value: "செயற்கை நுண்ணறிவு ஆய்வாளர்", label: "AI Researcher (செயற்கை நுண்ணறிவு ஆய்வாளர்)" },
  { value: "செயற்கை அறிவியல் ஆராய்ச்சி", label: "Artificial Science Researcher (செயற்கை அறிவியல் ஆராய்ச்சி)" },
  { value: "சங்க பரிசோதகர்", label: "Archaeologist (சங்க பரிசோதகர்)" },

  // Design & Architecture
  { value: "ஆர்கிடெக்ட்", label: "Architect (ஆர்கிடெக்ட்)" },

  // Other / General
  { value: "பொதுவாக வேலை செய்பவர்", label: "General Worker (பொதுவாக வேலை செய்பவர்)" },
  { value: "அறிகுறி கலைஞர்", label: "Sign Language Artist (அறிகுறி கலைஞர்)" },
  { value: "சலூன்", label: "Saloon (சலூன்)" },
  { value: "TNPL", label: "TNPL (TNPL)" }
];

// src/config/familyRelationships.js

const relationShips = [
  { value: "அப்பா", label: "Father (அப்பா)" },
  { value: "அம்மா", label: "Mother (அம்மா)" },
  { value: "மகன்", label: "Son (மகன்)" },
  { value: "மகள்", label: "Daughter (மகள்)" },
  { value: "மனைவி", label: "Wife (மனைவி)" },
  { value: "கணவர்", label: "Husband (கணவர்)" },
  { value: "இல்லை", label: "NA (இல்லை)" },
  { value: "தம்பி", label: "Younger Brother (தம்பி)" },  // Younger Brother
  { value: "அண்ணன்", label: "Elder Brother (அண்ணன்)" },  // Elder Brother
  { value: "தங்கை", label: "Younger Sister (தங்கை)" },  // Younger Sister
  { value: "அக்கா", label: "Elder Sister (அக்கா)" },  // Elder Sister
  { value: "இளைய மைத்துனி", label: "Younger Sister-in-law (இளைய மைத்துனி)" },  // Younger Sister-in-law
  { value: "மூத்த மைத்துனி", label: "Elder Sister-in-law (மூத்த மைத்துனி)" },  // Elder Sister-in-law
  { value: "மருமகள்", label: "Daughter-in-law (மருமகள்)" },  // Elder Sister-in-law
  { value: "பேத்தி", label: "Grand Daughter (பேத்தி)" },
  { value: "பேரன்", label: "Grand Son (பேரன்)" },
  { value: "தாத்தா", label: "Grandfather (தாத்தா)" },
  { value: "பாட்டி", label: "Grandmother (பாட்டி)" },
  { value: "சித்தப்பா", label: "Uncle - Father's Younger Brother (சித்தப்பா)" },
  { value: "பெரியப்பா", label: "Uncle - Father's Elder Brother (பெரியப்பா)" },
  { value: "அத்தை", label: "Aunt - Father's Sister (அத்தை)" },
  { value: "சித்தி", label: "Aunt - Mother's Younger Sister (சித்தி)" },
  { value: "மருமகன்", label: "Son-in-law (மருமகன்)" },
  { value: "தம்பி மனைவி", label: "Younger Brother's Wife (தம்பி மனைவி)" },

];



const customGroups = [
  { value: "சவரத்தொழில்", label: "சவரத்தொழில்" },
  { value: "மகள் வீடு", label: "மகள் வீடு (திருமணத்திற்கு பிறகு)" },
  { value: "புளியம்பட்டி-வேட்டுவக்கவுண்டர்", label: "புளியம்பட்டி-வேட்டுவக்கவுண்டர்" },
  { value: "அத்திப்பாளையம் கிராமம்", label: "அத்திப்பாளையம் கிராமம்" },
  { value: "முதலியார்", label: "முதலியார்" },
  { value: "வன்னியர் குலம்", label: "வன்னியர் குலம்" },
  { value: "இல்லை", label: "NA (இல்லை)" },
];

const statusExplanation = {
  draft: "📝 குடிபாடு உறுதிப்படுத்தப்படவில்லை",
  inactive: "❌ நீக்கப்பட்டது",
  pending: "⚠️⏳ Applied by public-பொது மக்களால் விண்ணப்பிக்கப்பட்டது",
  active: "✅",
};

const relationshipPriority = {
  "மனைவி": 1,
  "கணவர்": 1,
  "மகன்": 2,
  "மகள்": 2,
  "அப்பா": 3,
  "அம்மா": 3,
  "தம்பி": 4,
  "அண்ணன்": 4,
  "தங்கை": 4,
  "அக்கா": 4,
  "மருமகள்": 5,
  "மருமகன்": 5,
  "பேத்தி": 6,
  "பேரன்": 6,
  "தாத்தா": 7,
  "பாட்டி": 7,
  "சித்தப்பா": 8,
  "பெரியப்பா": 8,
  "அத்தை": 8,
  "சித்தி": 8,
  "இளைய மைத்துனி": 9,
  "மூத்த மைத்துனி": 9,
  "தம்பி மனைவி": 10,
  "இல்லை": 99, // NA
};

export { businessNames, relationShips, customGroups, statusExplanation, relationshipPriority };
